// extracted by mini-css-extract-plugin
export var centerText = "_cq-8";
export var container = "_cq-0";
export var doughnutContainer = "_cq-7";
export var legend = "_cq-a";
export var legendItemColorDisplay = "_cq-b";
export var legendItemLabel = "_cq-d";
export var legendItemValue = "_cq-c";
export var lg = "_cq-5";
export var maxWidth = "_cq-9";
export var md = "_cq-4";
export var responsive = "_cq-6";
export var sm = "_cq-3";
export var xs = "_cq-2";
export var xxs = "_cq-1";